import { MessageMedium } from 'constants/messageMediums';
import { lowerCaseMessageMedium } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';

export const MESSAGE_MEDIUM_CARD_TEST_ID = 'medium-card';

export const messageMediumInfoText = `The channel frequency rule is applied cumulatively to all message types that do not have their own frequency rule.`;

export const createMessageMediumHeaderDescription = (messageMedium: MessageMedium) =>
  `Cap the number of marketing ${lowerCaseMessageMedium(
    messageMedium,
  )} messages your users receive in a given time period.`;
